import Vue from 'vue';
export default Vue.extend({
    props: {
        pageNumber: { type: Number, required: true },
        pageSize: { default: 10, type: Number },
        count: { type: Number, required: true }
    },
    computed: {
        hasNext() {
            return this.pageNumber < this.pageCount;
        },
        hasPrev() {
            return this.pageNumber > 1;
        },
        pageCount() {
            return Math.ceil(this.count / this.pageSize);
        },
        items() {
            const maxLength = 5;
            if (this.pageCount <= maxLength) {
                return this.range(1, this.pageCount);
            }
            const even = maxLength % 2 === 0 ? 1 : 0;
            const left = Math.floor(maxLength / 2);
            const right = this.pageCount - left + 1 + even;
            if (this.pageNumber >= 3 && this.pageNumber <= right - 1) {
                return [this.pageNumber - 2, this.pageNumber - 1, this.pageNumber, this.pageNumber + 1, this.pageNumber + 2];
            }
            else {
                return [
                    ...this.range(1, left),
                    '...',
                    ...this.range(this.pageCount - left + 1 + even, this.pageCount)
                ];
            }
        }
    },
    methods: {
        changePage(page) {
            this.$emit('changePage', page);
        },
        // js doesn't have a range function.
        range(from, to) {
            const range = [];
            from = from > 0 ? from : 1;
            for (let i = from; i <= to; i++) {
                range.push(i);
            }
            return range;
        }
    }
});
